import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  Divider,
  useMediaQuery,
  useTheme,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import HomeIcon from "@mui/icons-material/Home";
import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from "@mui/material/Badge";

// import InfoIcon from "@mui/icons-material/Info";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import PeopleIcon from "@mui/icons-material/People";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import AssignmentIcon from "@mui/icons-material/Assignment";
import GroupIcon from "@mui/icons-material/Group";
import BuildIcon from "@mui/icons-material/Build";
import "./navbar.css";
import { NotificationContext } from "../utils/NotificationContext";
import Menu from '@mui/material/Menu';
import InfoIcon from '@mui/icons-material/Info';
import logo from "../assets/CrewGenix-removebg-preview.png"
import LoginIcon from '@mui/icons-material/Login';

const Navbar = () => {
  const [userType, setUserType] = useState(localStorage.getItem("userType"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [userId, setUserId] = useState(localStorage.getItem("urlID"));
  const [token, setToken] = useState(localStorage.getItem("token"))
  const { notifications, markAllAsViewed } = useContext(NotificationContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleNotificationClick = (event) => {
    setAnchorEl(event.currentTarget);
    markAllAsViewed(); // mark notifications as viewed
  };
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    setUserType(localStorage.getItem("userType"));
    setUserId(localStorage.getItem("urlID"));
    setToken(localStorage.getItem("token"));
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("userType");
    localStorage.removeItem("user id");
    localStorage.removeItem("token");
    setUserType(null);
    navigate("/login");
  };

  const toggleMobileMenu = () => {
    setMobileOpen(!mobileOpen);
  };

  /** Smooth Scrolling Function */
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const navigateToSection = (sectionId) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: sectionId } });
    } else {
      scrollToSection(sectionId);
    }
  };

  /** Scroll to Top when clicking "Home" on the same page */
  const handleHomeClick = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  /** Role-Based Navigation Links */
  const getNavLinks = () => {
    if (location.pathname === "/login" || location.pathname === "/") {
      return [
        { label: "Home", icon: <HomeIcon />, onClick: handleHomeClick },
        { label: "Services", icon: <BuildIcon />, onClick: () => navigateToSection("services") },
        { label: "Contact Us", icon: <ContactMailIcon />, onClick: () => navigateToSection("contact") },
        { label: "About Us", icon: <InfoIcon />, onClick: () => navigateToSection("about") },
        {
          label: "CrewGenix Job Portal",
          icon: <LoginIcon />,
          onClick: () => window.location.href = "https://https://crewgenix.com/seajobs/"
        }, { to: "/login", label: "CrewGenix Login" },
        { to: "/signup", label: "CrewGenix Signup" },
      ];
    } else if (userType === "admin" || userType === "team_leader" || userType === "BSE") {
      return [
        { to: "/vessel_owner_table", label: "Vessel Owner", icon: <PersonOutlineIcon /> },
        { to: "/VesselManagerTable", label: "Vessel Manager", icon: <PeopleIcon /> },
        { to: "/vessel_Table", label: "Vessels", icon: <DirectionsBoatIcon /> },
        { to: "/CrewingAgentTable", label: "Crewing Agent", icon: <PeopleIcon /> },
        { to: "/CrewProfileTable", label: "Crew", icon: <GroupIcon /> },
        { to: "/ContractTable", label: "Contract", icon: <AssignmentIcon /> },
      ];
    } else if (userType === "Vessel_vendor") {
      return [{ to: "/Vesselvendor", label: "Vessel Vendor" }];
    } else if (userType === "crewing_agent") {
      return [
        // { to: `/ContractTable/${userId}`, label: "Contract Table", icon: <AssignmentIcon /> },
        // { to: `/vesselsforagent/${userId}`, label: "Vessels", icon: <DirectionsBoatIcon /> },
      ];
    }
    return [];
  };

  const navLinks = getNavLinks();
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="sticky" className="navbar">
      <Toolbar className="toolbar">
        {/* Logo */}
        {userType === "admin" || userType === "BSE" ? (
          <Typography variant="h6" component={Link} to="/AdminDashboard" className="logo">
            {/* <img src="/assets/CrewGenix.png" alt="logo" className="logoImage" /> */}
            <img src={logo} alt="logo" className="logoImage" />
          </Typography>
        ) : (
          <Typography variant="h6" component={Link} to="/" className="logo">
            {/* <img src="/assets/CrewGenix.png" alt="logo" className="logoImage" /> */}
            <img src={logo} alt="logo" className="logoImage" />
          </Typography>
        )}


        {/* Desktop Navigation */}
        {!isMobile && (
          <Box className="desktop-nav">
            {navLinks.map((link, index) => (
              <Button
                key={index}
                component={link.to ? Link : "button"}
                to={link.to || undefined}
                onClick={link.onClick || undefined}
                className="nav-link"
              >
                {link.icon} {link.label}
              </Button>
            ))}
            {!navLinks.some(link => link.label === "Client Login") && !!userType && (
              <Button onClick={handleLogout} className="logout-btn">
                <LogoutIcon /> Logout
              </Button>
            )}
          </Box>
        )}

        {/* Mobile Menu Button */}
        {isMobile && (
          <IconButton className="mobile-menu-btn" onClick={toggleMobileMenu} color="inherit">
            <MenuIcon />
          </IconButton>
        )}
      </Toolbar>
      {/* <IconButton color="inherit" onClick={handleNotificationClick}>
  <Badge badgeContent={notifications.filter((n) => !n.viewed).length} color="error">
    <NotificationsIcon />
  </Badge>
</IconButton> */}

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {notifications.length === 0 ? (
          <Typography sx={{ p: 2 }}>No notifications</Typography>
        ) : (
          notifications.map((notif, index) => (
            <Box key={index} sx={{ px: 2, py: 1, maxWidth: "300px", whiteSpace: "normal" }}>
              <Typography
                variant="body2"
                color={notif.viewed ? "textSecondary" : "textPrimary"}
              >
                {notif.message}
              </Typography>
              <Divider />
            </Box>
          ))
        )}
      </Menu>


      {/* Mobile Drawer */}
      <Drawer anchor="left" open={mobileOpen} onClose={toggleMobileMenu} className="mobile-drawer">
        <List className="mobile-menu">
          {navLinks.map((link, index) => (
            <ListItem
              key={index}
              button
              component={link.to ? Link : "button"}
              to={link.to || undefined}
              onClick={() => {
                if (link.onClick) link.onClick();
                toggleMobileMenu();
              }}
            >
              {link.icon} {link.label}
            </ListItem>
          ))}
          <Divider />
          {!!userType && (
            <ListItem button onClick={handleLogout} className="mobile-logout">
              <LogoutIcon /> Logout
            </ListItem>
          )}
        </List>
      </Drawer>
    </AppBar>
  );
};

export default Navbar;
